import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { getEntity, updateEntity, createEntity, reset } from './wechat-user-2.reducer';
import { IWechatUser2 } from 'app/shared/model/wechat-user-2.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';

export interface IWechatUser2UpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const WechatUser2Update = (props: IWechatUser2UpdateProps) => {
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);

  const { wechatUser2Entity, loading, updating } = props;

  const handleClose = () => {
    props.history.push('/wechat-user-2');
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }
  }, []);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const entity = {
        ...wechatUser2Entity,
        ...values,
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="examsysApp.wechatUser2.home.createOrEditLabel">
            <Translate contentKey="examsysApp.wechatUser2.home.createOrEditLabel">Create or edit a WechatUser2</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : wechatUser2Entity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="wechat-user-2-id">
                    <Translate contentKey="global.field.id">ID</Translate>
                  </Label>
                  <AvInput id="wechat-user-2-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="nickNameLabel" for="wechat-user-2-nickName">
                  <Translate contentKey="examsysApp.wechatUser2.nickName">Nick Name</Translate>
                </Label>
                <AvField id="wechat-user-2-nickName" type="text" name="nickName" />
              </AvGroup>
              <AvGroup>
                <Label id="avatarUrlLabel" for="wechat-user-2-avatarUrl">
                  <Translate contentKey="examsysApp.wechatUser2.avatarUrl">Avatar Url</Translate>
                </Label>
                <AvField id="wechat-user-2-avatarUrl" type="text" name="avatarUrl" />
              </AvGroup>
              <AvGroup>
                <Label id="genderLabel" for="wechat-user-2-gender">
                  <Translate contentKey="examsysApp.wechatUser2.gender">Gender</Translate>
                </Label>
                <AvField id="wechat-user-2-gender" type="text" name="gender" />
              </AvGroup>
              <AvGroup>
                <Label id="countryLabel" for="wechat-user-2-country">
                  <Translate contentKey="examsysApp.wechatUser2.country">Country</Translate>
                </Label>
                <AvField id="wechat-user-2-country" type="text" name="country" />
              </AvGroup>
              <AvGroup>
                <Label id="provinceLabel" for="wechat-user-2-province">
                  <Translate contentKey="examsysApp.wechatUser2.province">Province</Translate>
                </Label>
                <AvField id="wechat-user-2-province" type="text" name="province" />
              </AvGroup>
              <AvGroup>
                <Label id="cityLabel" for="wechat-user-2-city">
                  <Translate contentKey="examsysApp.wechatUser2.city">City</Translate>
                </Label>
                <AvField id="wechat-user-2-city" type="text" name="city" />
              </AvGroup>
              <AvGroup>
                <Label id="languageLabel" for="wechat-user-2-language">
                  <Translate contentKey="examsysApp.wechatUser2.language">Language</Translate>
                </Label>
                <AvField id="wechat-user-2-language" type="text" name="language" />
              </AvGroup>
              <AvGroup>
                <Label id="openidLabel" for="wechat-user-2-openid">
                  <Translate contentKey="examsysApp.wechatUser2.openid">Openid</Translate>
                </Label>
                <AvField id="wechat-user-2-openid" type="text" name="openid" />
              </AvGroup>
              <AvGroup>
                <Label id="createDateLabel" for="wechat-user-2-createDate">
                  <Translate contentKey="examsysApp.wechatUser2.createDate">Create Date</Translate>
                </Label>
                <AvField id="wechat-user-2-createDate" type="date" className="form-control" name="createDate" />
              </AvGroup>
              <AvGroup>
                <Label id="tokenLabel" for="wechat-user-2-token">
                  <Translate contentKey="examsysApp.wechatUser2.token">Token</Translate>
                </Label>
                <AvField id="wechat-user-2-token" type="text" name="token" />
              </AvGroup>
              <AvGroup>
                <Label id="telLabel" for="wechat-user-2-tel">
                  <Translate contentKey="examsysApp.wechatUser2.tel">Tel</Translate>
                </Label>
                <AvField id="wechat-user-2-tel" type="text" name="tel" />
              </AvGroup>
              <Button tag={Link} id="cancel-save" to="/wechat-user-2" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  wechatUser2Entity: storeState.wechatUser2.entity,
  loading: storeState.wechatUser2.loading,
  updating: storeState.wechatUser2.updating,
  updateSuccess: storeState.wechatUser2.updateSuccess,
});

const mapDispatchToProps = {
  getEntity,
  updateEntity,
  createEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(WechatUser2Update);
